var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('inline-svg',{class:[{ 'fade-out': this.sharedStore.state.viewingProject }],attrs:{"id":"svg-bg","src":_vm.bgSvg},on:{"loaded":function($event){return _vm.svgLoaded($event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }